// extracted by css-extract-rspack-plugin
export default {"root":"KasAG_","message":"MCqUgD","button":"uajqWC"};